// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"25650ab3","52":"c5f47f42","313":"96ea1094","322":"697e73cb","422":"8017f441","549":"cb7464d7","558":"2736c98f","654":"d2102600","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};